import React from 'react';

import CreateTemplate from '../../Components/Create';
import Erros from './Erros';
import Form from './Form';
import validate from './Validation';

function transform({ nome, setor_id, ...data }) {
  return {
    nome,
    setor_id,
  };
}

const Create = (props) => (
  <CreateTemplate
    {...props}
    title="Nova Categoria de produto"
    validate={validate}
    onFailure={Erros}
    transform={transform}
    isBack
  >
    <Form />
  </CreateTemplate>
);

export default Create;
